<div class="mt-6 w-full flex flex-col gap-5">
  <p-toast></p-toast>

  <p-card>
    <ng-template #title>
      @if (rankingmode === 'user' && selectedNickname) {
        <h2>Hallo {{ selectedNickname }}</h2>
      }
      <h1>
        {{ 'label.rankings' | translate }}
        @if (rankingmode !== 'default') {
          - {{ selectedTimeFilterLabel }}
        }
      </h1>
    </ng-template>
    <div class="flex justify-end gap-2 mb-5">
      @if (rankingmode === 'default') {
        <p-datepicker
          [(ngModel)]="rangeDates"
          selectionMode="range"
          [readonlyInput]="true"
          [showIcon]="true"
          (onSelect)="selectDateRange()"
        />
        <p-iconfield class="ml-2">
          <p-inputicon class="fa-solid fa-magnifying-glass" />
          <input
            type="text"
            pInputText
            (input)="applyGlobalFilter($event)"
            placeholder="Suche"
            class="w-50"
          />
        </p-iconfield>
      } @else if (rankingmode === 'user') {
        <p-floatlabel class="w-full md:w-50">
          <p-select
            inputId="timefilter"
            [options]="timeFilterOptions"
            [(ngModel)]="selectedTimeFilter"
            optionLabel="text"
            optionValue="value"
            [placeholder]="'ranking.timePeriod' | translate"
            class="w-full"
            (onChange)="applyFilter()"
          />
          <label for="timefilter">{{ 'ranking.timePeriod' | translate }}</label>
        </p-floatlabel>
        <p-float-label class="w-full md:w-50">
          <p-select
            inputId="sortfilter"
            [options]="sortFilterOptions"
            [(ngModel)]="selectedSortFilter"
            optionLabel="text"
            optionValue="value"
            [placeholder]="'ranking.sortOrder' | translate"
            class="w-full"
            (onChange)="applyFilter()"
          />
          <label for="sortfilter">{{ 'ranking.sortOrder' | translate }}</label>
        </p-float-label>
      }
    </div>
    @if (rankingmode === 'default') {
      <p-table
        #ranking
        [value]="rankingService.rankings()"
        stripedRows
        showGridlines
        dataKey="id"
        [resizableColumns]="true"
        columnResizeMode="expand"
        [paginator]="true"
        [rows]="25"
        [rowsPerPageOptions]="[25, 50, 75, 100]"
        sortField="total_points"
        [sortOrder]="-1"
        [scrollable]="true"
        [loading]="false"
        [tableStyle]="{ 'min-width': '50rem' }"
        [globalFilterFields]="['nickname']"
      >
        <ng-template #header>
          <tr>
            <th rowspan="2" pSortableColumn="nickname" pResizableColumn>
              {{ 'ranking.nickname' | translate }}
              <p-sortIcon field="nickname" />
              <p-columnFilter
                type="text"
                field="nickname"
                display="menu"
              ></p-columnFilter>
            </th>
            <th rowspan="2" pSortableColumn="total_points" pResizableColumn>
              {{ 'ranking.total_points' | translate }}
              <p-sortIcon field="total_points" />
              <p-columnFilter
                type="numeric"
                field="total_points"
                display="menu"
              ></p-columnFilter>
            </th>
            <th rowspan="2" pSortableColumn="total_parcours" pResizableColumn>
              {{ 'ranking.total_parcours' | translate }}
              <p-sortIcon field="total_parcours" />
              <p-columnFilter
                type="numeric"
                field="total_parcours"
                display="menu"
              ></p-columnFilter>
            </th>
            <th rowspan="2" pSortableColumn="total_length" pResizableColumn>
              {{ 'ranking.total_length' | translate }}
              <p-sortIcon field="total_length" />
              <p-columnFilter
                type="numeric"
                field="total_length"
                display="menu"
              ></p-columnFilter>
            </th>
            <th rowspan="2" pSortableColumn="total_height" pResizableColumn>
              {{ 'ranking.total_height' | translate }}
              <p-sortIcon field="total_height" />
              <p-columnFilter
                type="numeric"
                field="total_height"
                display="menu"
              ></p-columnFilter>
            </th>
            <th
              rowspan="2"
              pSortableColumn="total_ropeway_meters"
              pResizableColumn
            >
              {{ 'ranking.total_ropeway_meters' | translate }}
              <p-sortIcon field="total_ropeway_meters" />
              <p-columnFilter
                type="numeric"
                field="total_ropeway_meters"
                display="menu"
              ></p-columnFilter>
            </th>
          </tr>
        </ng-template>
        <ng-template #body let-ranking>
          <tr>
            <td>{{ ranking.nickname }}</td>
            <td>{{ ranking.total_points }}</td>
            <td>{{ ranking.total_parcours }}</td>
            <td>{{ ranking.total_length }}</td>
            <td>{{ ranking.total_height }}</td>
            <td>{{ ranking.total_ropeway_meters }}</td>
          </tr>
        </ng-template>
      </p-table>
    } @else {
      <p-table
        #userRanking
        [value]="rankingService.userRankings()"
        stripedRows
        showGridlines
        dataKey="id"
        [resizableColumns]="true"
        columnResizeMode="expand"
        [paginator]="false"
        [rows]="25"
        [rowsPerPageOptions]="[25, 50, 75, 100]"
        [sortOrder]="-1"
        [scrollable]="true"
        [loading]="false"
        [tableStyle]="{ 'min-width': '50rem' }"
      >
        <ng-template #header>
          <tr>
            <th rowspan="2">
              {{ 'ranking.position' | translate }}
            </th>
            <th rowspan="2" pResizableColumn>
              {{ 'ranking.nickname' | translate }}
            </th>
            <th rowspan="2" pResizableColumn>
              {{ 'ranking.total_points' | translate }}
            </th>
            <th rowspan="2" pResizableColumn>
              {{ 'ranking.total_parcours' | translate }}
            </th>
            <th rowspan="2" pResizableColumn>
              {{ 'ranking.total_length' | translate }}
            </th>
            <th rowspan="2" pResizableColumn>
              {{ 'ranking.total_height' | translate }}
            </th>
            <th rowspan="2" pResizableColumn>
              {{ 'ranking.total_ropeway_meters' | translate }}
            </th>
          </tr>
        </ng-template>
        <ng-template #body let-ranking>
          <tr
            [pSelectableRow]="ranking"
            (click)="viewUserRanking(ranking)"
            [class]="ranking.is_current_user ? 'current-user-row' : ''"
          >
            <td>{{ ranking.position }}</td>
            <td>{{ ranking.nickname }}</td>
            <td>{{ ranking.total_points }}</td>
            <td>{{ ranking.total_parcours }}</td>
            <td>{{ ranking.total_length }}</td>
            <td>{{ ranking.total_height }}</td>
            <td>{{ ranking.total_ropeway_meters }}</td>
          </tr>
        </ng-template>
      </p-table>
    }
  </p-card>
</div>
